import { cn as e } from "../shared/utils.js";
import { Badge as t } from "./badge.js";
import { forwardRef as n } from "react";
import { jsx as r } from "react/jsx-runtime";
import { cva as i } from "class-variance-authority";
//#region src/badge/tag.tsx
var a = i("", {
	defaultVariants: { size: "md" },
	variants: { size: {
		sm: "min-h-6 px-2.5 py-1 text-sm",
		md: "min-h-8 px-3 py-1.5 text-base"
	} }
}), o = n(({ children: n, size: i, className: o, ...s }, c) => /* @__PURE__ */ r(t, {
	ref: c,
	color: "blue",
	size: "lg",
	shape: "pill",
	className: e(a({
		className: o,
		size: i
	})),
	...s,
	children: n
}));
o.displayName = "Tag";
//#endregion
export { o as Tag };
